import { gql } from '@anyx/common-graphql';

export const GET_INACTIVE_SALE_CHANNELS = gql(/* GraphQL */ `
  query GetInactiveSaleChannels($storeId: Long!) {
    onboarding(storeId: $storeId) {
      inactiveSaleChannelCount
    }
  }
`);
